module.exports = __webpack_public_path__ + "static/paleo-887486dcda4df0ae4718e8c6aa78a995.png";